export const getProfileOpened = (state) => state.profile.profileOpened
export const getUser = (state) => state.profile.user